import { Component, OnInit } from '@angular/core';
import { RequestApprovalConfigDto } from 'src/app/models/RequestApprovalConfigDto';
import { RequestapprovalconfigsService } from 'src/app/services/requestapprovalconfigs.service';
import { RequestApprovalsService } from 'src/app/services/requestapprovals.service';

@Component({
  selector: 'app-aprovalconfig',
  templateUrl: './aprovalconfig.component.html',
  styleUrls: ['./aprovalconfig.component.css']
})
export class AprovalconfigComponent implements OnInit {

  constructor(private requestApprovalService: RequestapprovalconfigsService) { }
  rRequestApprovalConfigs:RequestApprovalConfigDto[]=[];
  ngOnInit(): void {
    this.loadRecords();

  }


 async  loadRecords()
  {
    let  resLocations = await this.requestApprovalService.getApprovalLevels().toPromise(); 
    this.rRequestApprovalConfigs = <RequestApprovalConfigDto[]> resLocations.responseData;

  }

}
